import { UMIcon } from '../../urbanmap/_components';
import { UMR } from './tokens';

interface Props {
  label: string;
  onRemove: () => void;
  removeLabel: string;
}

/**
 * Étiquette grise reprenant le design des tags UrbanMap (filtres, exports) :
 * fond gris 200, bord gris 400, angles droits, 26 px de haut.
 */
export function Chip({ label, onRemove, removeLabel }: Props) {
  return (
    <li
      style={{
        display: 'flex', alignItems: 'center', gap: 4, height: 26, padding: '0 4px 0 8px',
        background: UMR.tagBg, border: `1px solid ${UMR.borderInput}`, color: UMR.black,
        font: `400 14px/16px ${UMR.font}`, maxWidth: '100%',
      }}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
      <button
        type="button"
        aria-label={removeLabel}
        onClick={onRemove}
        style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, display: 'flex' }}
      >
        <UMIcon name="close" family="icons" size={16} color={UMR.textSecondary} />
      </button>
    </li>
  );
}

/** Conteneur d'étiquettes : liste horizontale qui passe à la ligne. */
export const chipListStyle: React.CSSProperties = {
  listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexWrap: 'wrap', gap: 4,
};
